// src/utils/enum-normalizers.ts
/**
 * Il backend serializza RequestType come stringa (es. "Bozzetto") via converter custom,
 * mentre RequestStatus esce come numero. I tipi FE si aspettano sempre numeri
 * (RequestType.Bozzetto = 1). Queste helper normalizzano entrambi i casi, così ogni
 * servizio che legge type/status da una risposta API ottiene sempre un numero.
 */

const TYPE_NAME_TO_NUM: Record<string, number> = {
  Bozzetto: 1,
  Campionatura: 2,
  Produzione: 3,
  Gamma: 4,
};

const STATUS_NAME_TO_NUM: Record<string, number> = {
  New: 1,
  InProgress: 2,
  PendingCompletion: 3,
  Completed: 4,
  Cancelled: 5,
  Suspended: 6,
  PreCampionatura: 7,
  PreCampionaturaCompleted: 8,
};

export function toRequestTypeNum(v: any): number {
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    const asNum = Number(v);
    if (!Number.isNaN(asNum) && asNum > 0) return asNum;
    return TYPE_NAME_TO_NUM[v] ?? 0;
  }
  return 0;
}

export function toRequestStatusNum(v: any): number {
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    const asNum = Number(v);
    if (!Number.isNaN(asNum) && asNum > 0) return asNum;
    return STATUS_NAME_TO_NUM[v] ?? 0;
  }
  return 0;
}
